import type { FaqItem, WhyItem } from "@/types/home";
import { ShieldCheck, Target, BrainCircuit, Cpu, GitBranch, Handshake } from "@/icons";
// import { ShieldCheck, Gauge, Users, Zap, Clock, Award } from "@/icons";

export const faqs: FaqItem[] = [
  {
    question: "What software development services do you provide?",
    answer:
      "We provide custom software development, enterprise applications, web applications, e-commerce platforms, mobile applications, ERP systems, CRM solutions, AI-powered business solutions, workflow automation, cloud solutions, API integrations and long-term application support.",
  },
  {
    question: "Do you develop custom software tailored to our business?",
    answer:
      "Yes. Every organisation operates differently. We analyse your business processes, understand your operational goals and develop software tailored specifically to your requirements instead of forcing your teams to adapt to generic off-the-shelf products.",
  },
  {
    question: "Can you modernise or upgrade our existing software?",
    answer:
      "Absolutely. We can enhance legacy applications, migrate systems to modern technologies, improve performance, strengthen security and introduce new features while minimising disruption to your business.",
  },
  {
    question: "Do you build AI-powered business solutions?",
    answer:
      "Yes. We develop AI-powered business solutions including AI agents, intelligent chatbots, workflow automation, semantic search, predictive analytics and custom AI integrations that improve productivity and business decision-making.",
  },
  {
    question: "Which technologies do you work with?",
    answer:
      "We select technologies based on your business requirements rather than following a one-size-fits-all approach. Our expertise includes React, Next.js, React Native, TypeScript, NestJS, PHP, CodeIgniter, Laravel, Python, PostgreSQL, MySQL, MongoDB, Docker, cloud platforms and modern DevOps practices.",
  },
  {
    question: "How long does a typical project take?",
    answer:
      "Project duration depends on complexity and scope. Small websites may take a few weeks, while enterprise applications are delivered incrementally through agile milestones with regular demonstrations and client feedback.",
  },
  {
    question: "Will you provide support after deployment?",
    answer:
      "Yes. We offer post-deployment support, maintenance, performance optimisation, feature enhancements, security updates and long-term technical assistance to ensure your solution continues to evolve with your business.",
  },
  {
    question: "How do we get started?",
    answer:
      "Simply contact us to discuss your business requirements. We'll understand your objectives, evaluate the scope, recommend the most suitable technology approach and provide a project roadmap before any development begins.",
  },
  {
    question:
      "Do you sign Non-Disclosure Agreements (NDAs)?",
    answer:
      "Yes. We understand the importance of confidentiality. We are happy to sign a Non-Disclosure Agreement before discussing sensitive business ideas, intellectual property or proprietary information."
  },
  {
    question:
      "Can you integrate with our existing software?",

    answer:
      "Yes. We can integrate your new solution with existing ERP systems, CRM platforms, accounting software, payment gateways, HR systems, third-party APIs and other enterprise applications to ensure seamless business operations."
  },
  {
    question:
      "Do you work with startups as well as established organisations?",

    answer:
      "Yes. We work with startups, SMEs, enterprises, educational institutions, healthcare providers and government organisations. Every engagement is tailored to the organisation's size, objectives and budget."
  }
];

export const whyChooseUs = [
  {
    title: "Business-First Approach",
    description:
      "Every solution starts with understanding your business goals, operational challenges and long-term vision before any technology decisions are made.",
    icon: Target,
  },
  {
    title: "Enterprise-Grade Engineering",
    description:
      "Our applications are designed with security, scalability, maintainability and performance as core principles from day one.",
    icon: ShieldCheck,
  },
  {
    title: "AI-Powered Innovation",
    description:
      "We help organisations leverage Artificial Intelligence to automate workflows, improve decision-making and create smarter digital experiences.",
    icon: BrainCircuit,
  },
  {
    title: "Future-Ready Technology",
    description:
      "We use proven technologies and modern development practices to deliver reliable, future-ready software solutions.",
    icon: Cpu,
  },
  {
    title: "Transparent Delivery",
    description:
      "Regular progress updates, collaborative planning and agile delivery ensure complete visibility throughout the project lifecycle.",
    icon: GitBranch,
  },
  {
    title: "Long-Term Partnership",
    description:
      "Our engagement doesn't end at deployment. We provide ongoing support, optimisation and continuous improvement as your business grows.",
    icon: Handshake,
  },
];

